import * as firebase from 'firebase/app';
import DEFINES from "@/defines";
import Vue from 'vue';

const initialize = () => {
  return firebase.initializeApp({
    apiKey: DEFINES.FIREBASE_API_KEY,
    authDomain: DEFINES.FIREBASE_AUTH_DOMAIN,
    databaseURL: DEFINES.FIREBASE_DATABASE_URL,
    projectId: DEFINES.FIREBASE_PROJECT_ID,
    storageBucket: DEFINES.FIREBASE_STORAGE_BUCKET,
    messagingSenderId: DEFINES.FIREBASE_MESSAGING_SENDER_ID,
    appId: DEFINES.FIREBASE_APP_ID,
    measurementId: DEFINES.FIREBASE_MEASUREMENT_ID
  });
}

initialize();
Vue.prototype.firebase = firebase;

